import moment from 'moment'
import { Variant } from '../components/NewServiceDrawerElement'
import { ActiveOrder } from '../types/NewDrawers.types'

export const getHeadTitle = (el: ActiveOrder, variant: Variant) => `${
  variant === 'opened' ? 'Открытая' : 'Закрытая'
} Заявка Сервис-центра  
        № ${el.requestId} от ${moment(el.requestDate).format('DD.MM.YYYY')}`

export const wrapperSx = {
  padding: '10px 0 0 40px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
}
